export default "__VITE_ASSET__DMRuGO$n__"